var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-btn v-btn--icon v-btn--outline v-btn--small theme--light ma-0 pa-0"},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }